import { z } from "zod";
import { UserSchema } from "./User";

export const BaseChangelogSchema = z.object({
  id: z.number(),
  fieldType: z.number(),
  fieldName: z.string(),
  oldValue: z.union([z.string(), z.boolean()]),
  newValue: z.union([z.string(), z.boolean()]),
  modificationDate: z.string(),
  attribute: z.any(),
  userUser: UserSchema,
});

export type BaseChangelog = z.infer<typeof BaseChangelogSchema>;

export type Changelog<
  T extends Record<string, unknown> = Record<never, never>
> = BaseChangelog & T;
